export function calculateRangeInterval(
	unitRange: number,
	newRangeClasses: number,
	precision: number,
) {
	let interval = unitRange / newRangeClasses;
	// If the interval is 0 then make it the minimum increment
	if (interval === 0) {
		interval = +(1 / Math.pow(10, precision)).toFixed(precision);
	} else {
		interval = +interval.toFixed(precision);
	}

	// If the precision is 0 then make sure the interval is at least 1
	if (precision === 0) {
		interval = Math.max(interval, 1);
	}

	return interval;
}
